import { ColumnFormatter } from 'src/app/model/formatters/columnformatter';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { SubScriptionMgr } from './../../../model/SubscriptionMgr';
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSelectDialogService, SelectOption, ModalSelectParams } from './modal-select-dialog.service';

@Component({
  selector: 'app-modal-select-dialog',
  templateUrl: './modal-select-dialog.component.html',
  styleUrls: ['./modal-select-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalSelectDialogComponent implements AfterViewInit {
  public options: Array<SelectOption> = [];
  public handler: AnyHandler;
  public title: string = '';
  public listingReady = false;
  public filtered: Array<SelectOption> = [];
  private params: ModalSelectParams;
  @ViewChild('listing', { static: true }) public listing: ElementRef<HTMLDivElement>;

  private _filterText = '';
  public set filterText(filter: string) {
    this._filterText = filter;
    this.Filter();
  }
  public get filterText(): string {
    return this._filterText;
  }

  constructor(private domNode: ElementRef, private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef) { }
  ngAfterViewInit() {
    if (!this.listing) {
      window.requestAnimationFrame(() => {
        this.ngAfterViewInit();
      })
      return;
    }
    (this.listing.nativeElement.firstChild as HTMLLIElement).focus();
  }
  Show(params: ModalSelectParams) {
    this.params = params;

    this.filterText = '';
    this.title = 'Select an option';
    this.Filter();
    let maxWidth = 12 * 16; // 12rem
    for (const option of this.options) {
      maxWidth = Math.max(ColumnFormatter.TextWidth(option.label), maxWidth);
    }
    this.domNode.nativeElement.style.setProperty('width', maxWidth + 16);
    this.handler = params.handler;
    this._filterText = '';
    this.listingReady = true;
    this.cdr.detectChanges();
    this.domNode.nativeElement.focus();
  }
  Filter() {
    this.listingReady = false;
    this.cdr.detectChanges();
    this.options = this.params.options.filter((option) => {
      const label = option.label.toLowerCase();
      if (this._filterText === '') return true;
      const filterParts = this._filterText.trim().toLowerCase().split(' ');
      for (const part of filterParts) {
        if (label.indexOf(part) > -1) return true;
      }
      return false;
    });
    this.listingReady = true;
    this.cdr.detectChanges();
  }
  ClearFilter() {
    this._filterText = '';
    this.cdr.detectChanges();
    this.Filter();
  }
  Select(value: any) {
    if (!!this.handler) this.handler(value);
    this.activeModal.close();
  }
  HandleKey(event, val: any) {
    switch (event.key) {
      case 'Enter':
      case 'Space':
      case ' ':
        this.Select(val)
        break;
      case 'ArrowUp':
        if (!!document.activeElement.previousElementSibling) {
          (document.activeElement.previousElementSibling as HTMLLIElement).focus();
        }
        event.preventDefault();
        (event as KeyboardEvent).stopImmediatePropagation();
        break;
      case 'ArrowDown':
        console.log(document.activeElement.innerHTML);
        if (!!document.activeElement.nextElementSibling) {
          (document.activeElement.nextElementSibling as HTMLLIElement).focus();
        }
        event.preventDefault();
        (event as KeyboardEvent).stopImmediatePropagation();
        break;
    }
  }
  HandleFilterClick(event: any) {
    if (!!event.target) {
      const target: HTMLDivElement = event.target as HTMLDivElement;
      if (target.offsetLeft + target.offsetWidth - 20 < event.clientX) {
        this.ClearFilter();
      }
    }
  }
  UpdateCursor(event: any) {
    if (!!event.target) {
      const target: HTMLDivElement = event.target as HTMLDivElement;
      if ((target.offsetLeft + target.offsetWidth - 20) < event.offsetX) {
        target.classList.toggle('clearable',true);
      } else {
        target.classList.toggle('clearable',false);
      }
    }

  }

}


@Component({
  selector: 'app-modal-select-dialog-entry',
  template: ''
})
export class ModalSelectDialogEntryComponent implements OnDestroy {
  modalRef: NgbModalRef;
  subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private service: ModalSelectDialogService) {

    this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
      this.modalRef = this.modalService.open(ModalSelectDialogComponent, { backdrop: 'static', windowClass: 'modal-select-dialog' });
      (this.modalRef.componentInstance as ModalSelectDialogComponent).Show(info);
    });
  }
  ngOnDestroy(): void {
    this.subscriptionMgr.CancelSubscriptions();
  }
}
